<template>
	<span class="shp">
			
			<b-modal id="showShareEmailModal" hide-footer body-class="bodypaddingtop">
				  <template #modal-title> Reply Email</template> 
						
					
				 <b-container fluid class="p-1">
				  	<b-row class="mt-3 mb-2">
						<b-col >
						<!--{{userData}}
						{{subjectT}}
						{{ reversedMessage }} -->
							<form ref="form" @submit.stop.prevent="handleSubmitEmaitempl" >	
								<b-row>
								<b-col >
									<b-form-group label-for="subject-input" label-size="sm" label-class="mb-2" class="mb-1" :state="emailsendState.subject" invalid-feedback="Email Subject is required!" label="*Subject">
									<b-form-input id="walletkey-input" :state="emailsendState.subject" v-model="emailsend.subject"  @focusin="emailsendState.subject = null" size="sm"></b-form-input></b-form-group>
									
									
									
									
									
									
									<b-form-group label-for="mess-textarea" label-size="sm" label-class="mb-2" class="mb-1" :state="emailsendState.message" invalid-feedback="Message is required!"  label="*Message" >
										
									<!--<VueTrix  inputId="mess-textarea"  v-model="emailsend.message" placeholder="Type your message here" :state="emailsendState.message"  @focusin="emailsendState.message = null"/> --> 
										
										<vue-editor
										  id="mess-textarea"
										  useCustomImageHandler
										  @image-added="handleImageAdded"
										  v-model="emailsend.message" 
										  placeholder="Type your message here" 
										  :state="emailsendState.message" 
										  @focusin="emailsendState.message = null"
										>
										</vue-editor>
										
									</b-form-group>
									 
									
								</b-col>
								</b-row>
								
								<b-row class="mt-2">
									<b-col class="text-center bankAccountFotmbtnLayout ">
										 <b-button pill type="submit" variant="dark" class="mr-2" style="width: 100px;">Send</b-button>
										 
									</b-col>
								</b-row>
								</form>

								
						</b-col>
						
					</b-row>

				 
				 
				
			<!--<div>Selectedd: {{selectedmess}}</div> -->
				 
				  </b-container>
				  
				  
				</b-modal>


		</span>		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import { VueEditor } from "vue2-editor";
export default {
  name: 'ReplayEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  VueEditor
  },
  props: { 
	userData: {type: Object},	
	subjectT: {type: String},	
	fromEmail: {type: String},	
  },
  mounted(){
    this.inLodcard();
	
	/*self.emailsend.subject	=	self.userData.subject;
	console.log('adasd'+JSON.stringify(self.userData));
	console.log('adasd'+this.props.subjectT);*/
  },
  computed: {
   // console.log("created"+this.subjectT);
	/* reversedMessage: function () {
			console.log("created"+this.subjectT);
			self.emailsend.subject	=	self.userData.subject;
		  // `this` points to the vm instance
		  return 'tets';
		}*/
  },
  created() {
      //console.log("created"+this.subjectT);
	 
   },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		//sendEmailUrl: this.$root.WEBAPI+'secureapi/sendmessageEmailbulk',
		sendEmailUrl: this.$root.WEBAPI+'secureapi/sendmessageReplay',
		linkComments:'',
		iamiconfor:'',
		emailsend:{
				subject:'',
				message:''
				},
		emailsendState:{
			subject:null,
			message:null,
			
		},	
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			/*var self=this;
			self.emailsend.subject	=	self.userData.subject;*/
			console.log('adasd'+JSON.stringify(this.userData));
			
			
			
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		checkFormValidityemailtemp(){
			var valid = true;
			
				if(this.emailsend.subject.length < 3){
					valid = false;
					this.emailsendState.subject = false;
				}else{
					this.emailsendState.subject= true;
				}
				
				if(this.emailsend.message==''){
					valid = false;
					this.emailsendState.message = false;
				}else{
					this.emailsendState.message= true;
				}
			return valid;
			
		},
		handleSubmitEmaitempl(){
						 if (!this.checkFormValidityemailtemp()) {
						return;
						}
						var self = this;

						self.axios.post(self.sendEmailUrl, {
							accesskey: self.$session.get('access_key'),
							user_data: self.userData,
							data: self.emailsend,
							fromEmail: self.fromEmail,
						}).then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
										title: 'Email Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'success',
										solid: true,
										appendToast: true
								});
								
								self.emailsend={
									subject:'',
									message:''								
									};
								self.emailsendState = {
									subject:null,
									message:null,
								};
								self.$bvModal.hide('showShareEmailModal');
								//self.noAddwallet=0;
								//self.bulkTransferBtn=0;
								//self.initload();
								//self.inLodcard();
								//self.initProfile();
							}else{
								self.error_msg = response.data.message;
								self.$bvToast.toast(response.data.message, {
								title: 'Email',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
								});
							
							}

						}).catch(function (error) {
								alert(error);
						});
					
						

		},
		handleAttachmentRemove(file){

			console.log(file);
		},
		handleAttachmentAdd(event){
			console.log(event);
		},
		handleImageAdded(file, Editor, cursorLocation, resetUploader) {
		var self =this;
		  var formData = new FormData();
		  formData.append("image", file);
		  var urlUpload = this.$root.NEWAPIURL+'profileapi/updateEditorimage';
		  self.axios({
			url: urlUpload,
			method: "POST",
			data: formData
		  })
			.then(result => {
			  const url = 'https://www.alluraa.com/media/editor/'+result.data.result.imgsrc; // Get url from response
			  Editor.insertEmbed(cursorLocation, "image", url);
			  resetUploader();
			})
			.catch(err => {
			  console.log(err);
			});
		}
				

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
		$whiteColor: #ffffff;
		$blackColor: #000000;
		$themeColor: #a059d9;
		$themeColor2: #8507d6;
		$themeColor3: #b24bf1;
		$redColor: #e61583;
		$grey: #b9b9b9;
		$grey2: #a6a6a6;
		$themeLightColor: #f2e2ff;
		$themeDarkColor: #df007e;

		@mixin setBlackBoldTextStyles() {
		  font-size: 12px;
		  color: $blackColor;
		  font-weight: bold;
		}
	
		#showShareModal {
		.modal-header{
		padding: 8px;
		}
		
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}
	#showShareMessageModal {
		.modal-header{
		padding: 8px;
		}
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}

	#message-textarea {
	  border-color: $themeDarkColor;

	  :focus {
		border-color: $themeColor2;
	  }
	}
	
	.shoppopup>li{
	line-height:15px;
	}
	
	.card{
			margin-bottom: 12px;	
			box-shadow: 0px 0px 1px 0px #c6c6c6;
			
			.card-footer{
				background-color: #fff;
				border-top: 1px solid rgba(0,0,0,.125);
				.spCross{
					    font-size: 14px;
   						color: darkgray;
				}
			}

			.card-body{
				padding: 5px;
				.pImg{
					max-height: max-content;
				}

				.pTitle{
					font-size: smaller;
					font-weight: 200;
					color: #3f414d;
				}
			}
		}
		
		#radio-slots{
		    text-align: center;
			margin-left: 3%;
		}
		.myoption{
				.custom-control{				 
					margin-right: 20px !important;
					color: #515457d1;
				}
			/*.custom-control-inline{		 
				margin-right: 50px !important;
			}*/
		}
	
	.noteMess{
			font-size: 12px;
		}
		
		.sharepopupStardiaplay{ width: 37%;height: 13px;}
		
	/* EDITOR CLASS*/
.trix-toolbar-2{
	font-size: 10px;
}.trix-button-row{
	font-size: 10px;
}
.trix-content{
	height: 199px;
    overflow: scroll;
}

</style>
